import { LuCalendar, LuCalendarDays, LuCirclePlus, LuClock, LuSave } from 'react-icons/lu';
import { moduleTour as tour, OPTIONAL as opt } from '../defineTour';

// Landing-tab tour first; one tour per further tab below it.
const tours = [
  // exact: each booking opens at /appointments/:id.
  tour('appointments', '/appointments', 'appointments', [
    ['new', 'appointments.new', LuCirclePlus],
    ['hours', 'appointments.hours', LuClock, opt],
    ['bookings', 'appointments.bookings', LuCalendar, { placement: 'top', ...opt }],
  ], { exact: true }),

  tour('appointments_working_hours', '/appointments/working-hours', 'appointments', [
    ['hours', 'appointments_working_hours.hours', LuClock, { placement: 'top' }],
    ['week', 'appointments_working_hours.week', LuCalendarDays, { placement: 'left', ...opt }],
    ['save', 'appointments_working_hours.save', LuSave, { placement: 'left' }],
  ], { exact: true }),
];

export default tours;
